import { useCallback } from 'react';

import useClientState from '@/state/useClientState';

const useMwdAction = () => {
  const closeContextMenu = useClientState((state) => state.closeContextMenu);
  const deselectAll = useClientState((state) => state.deselectAll);

  /** Use this callback to execute any action if it should clear any selected items and also close the contextmenu after. */
  const executeAction = useCallback(
    async (action: (() => Promise<void>) | (() => void)) => {
      await Promise.all([Promise.resolve(action()), closeContextMenu()]);
      await deselectAll();
    },
    [closeContextMenu, deselectAll],
  );
  return { executeAction };
};
export default useMwdAction;
